import {NavList} from '@primer/react'
import {VerifiedHTMLText} from '@github-ui/safe-html/VerifiedHTML'
import type {ReactNode, Ref} from 'react'

import type {StackSectionStackEntry} from '../../../helpers/merge-box-status-calculator/stack-section-status'

export function StackEntryNavItem({
  entry,
  tabSuffix,
  className,
  isTitleMuted,
  leadingVisual,
  trailingVisual,
  trailingAction,
  entryRef,
  isCurrent,
  onClick,
}: {
  entry: StackSectionStackEntry
  tabSuffix: string
  className: string
  isTitleMuted: boolean
  leadingVisual: ReactNode
  trailingVisual: ReactNode
  trailingAction?: ReactNode
  entryRef?: Ref<HTMLAnchorElement>
  isCurrent?: boolean
  onClick?: () => void
}) {
  return (
    <NavList.Item
      ref={entryRef}
      href={`${entry.pull.url}${tabSuffix}`}
      aria-current={isCurrent}
      onClick={onClick}
      className={className}
    >
      <NavList.LeadingVisual>{leadingVisual}</NavList.LeadingVisual>
      <span className={isTitleMuted ? 'fgColor-muted' : ''}>
        {entry.pull.titleHtml !== undefined ? (
          <VerifiedHTMLText as="span" html={entry.pull.titleHtml} />
        ) : (
          entry.pull.title
        )}
      </span>
      <NavList.Description variant="block">
        <span className="fgColor-muted">
          #{entry.pull.number} · {entry.pull.headBranch}
        </span>
      </NavList.Description>
      <NavList.TrailingVisual>{trailingVisual}</NavList.TrailingVisual>
      {trailingAction}
    </NavList.Item>
  )
}
